import { css } from '@emotion/react';
// import { useSearch } from '@tanstack/react-router';
// import { CoachmarkTooltip, useCoachmarkTooltip } from '@frontend/analytics-shared';
import { IconName } from '@frontend/icons';
import { ContentSwitcher } from '@frontend/design-system';
import { VIEW_KEYS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';

export const ViewSwitcher = () => {
  // const { comparingLocations } = useSearch({ from: '/analytics/ai-receptionist' });
  const { view, changeView } = useAppointmentAnalyticsV2ShallowStore('view', 'changeView');

  const OPTIONS = [
    { value: VIEW_KEYS.CHART, label: 'Chart', iconName: 'analytics-small' },
    { value: VIEW_KEYS.TABLE, label: 'Table', iconName: 'table-small' },
  ];

  // const view = VIEW_KEYS.CHART;
  // const changeView = () => {};

  // const { shouldShow, recordShown, recordDismiss } = useCoachmarkTooltip('air-view-switcher-tooltip', {
  //   delayMs: 6000,
  // });

  // const inactiveOption = OPTIONS.find((option) => option.value !== view);
  // const isInactiveFirst = inactiveOption?.value === OPTIONS[0].value;

  // const showTooltip = shouldShow && !!inactiveOption && !comparingLocations

  return (
    <div css={wrapperStyles}>
      <ContentSwitcher key={view} defaultValue={view} onValueChange={changeView}>
        {OPTIONS.map((option) => (
          <ContentSwitcher.Option
            key={option.value}
            value={option.value}
            label={option.label}
            iconName={option.iconName as IconName}
          />
        ))}
      </ContentSwitcher>

      {/* {showTooltip && inactiveOption && (
        <CoachmarkTooltip
          text={VIEW_SWITCHER_TOOLTIP_COPY[inactiveOption.value]}
          placement='top-end'
          offset={11}
          dotCss={dotStyles(isInactiveFirst)}
          onShow={recordShown}
          onDismiss={recordDismiss}
        />
      )} */}
    </div>
  );
};

const wrapperStyles = css`
  position: relative;
  display: inline-flex;
`;

// const dotStyles = (isInactiveFirst: boolean) => css`
//   position: absolute;
//   top: -12px;
//   left: ${isInactiveFirst ? '25%' : '75%'};
//   transform: translateX(-50%);
// `;
